import axios from 'axios'
import Outil from '@/assets/js/utils.js'
const actions = {
  getFeatureList: async (param, { program = '', user = '' }) => {
    // const userId = localStorage.getItem('userId')
    const userId = Outil.getProgramReceiver().ownerUserId || user
    const programId = Outil.getProgramReceiver().ProgramId || program
    await axios
      .post(Outil.getUrl('/program/listFeatures'), { programId, userId })
      .then((res) => {
        if (res.data.errorCode == '0x0') {
          param.commit('ListFeatures', res.data.result)
        } else {
          // const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          // this.$message.info(errorInfo)
        }
      }).catch(() => {})
  },
  actionLBandInfo ({ commit }, data) {
    commit('setLBandInfo', data)
  }
}

export default actions
